export default __webpack_public_path__ + "static/media/icon_caster.5fc7eacc.png";